import Axios from 'axios'

const ENDPOINT = 'kpis'

/**
 * Get
 */
export const getObj = () => {
    return new Promise((resolve, reject) => {
        Axios.get(`/${ENDPOINT}`)
            .then((res) => {
                return resolve(res.data)
            })
            .catch((err) => {
                return reject(err)
            })
    })
}
